<template>
  <div class="moo-update-profile-modal" :style="styleObject">
    <button
      style="display: none"
      type="button"
      class="show-modal-update-profile"
      data-bs-toggle="modal"
      data-bs-target="#modal_update_profile"
    ></button>
    <button
      style="display: none"
      type="button"
      class="btn-hide-update-profile-modal"
      data-bs-target="#modal_update_profile"
      data-bs-dismiss="modal"
    ></button>
    <div id="custom-overlay" class="custom-modal-overlay"></div>
    <div
      class="modal modal-full fade"
      id="modal_update_profile"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal_update_profile"
      style="z-index: 10000"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="btn-close-modal" @click="closeModel()">
              <div>&times;</div>
            </div>
          </div>
          <div
            class="modal-body"
            style="padding: 0px"
          >
            <div class="page-header align-items-start">
              <div class="container">
                <div class="content">
                  <div class="p-3">
                    <section class="profile-form-card">
                      <h3 class="profile-form-title">Personal Information</h3>

                      <!-- is_populate_data = false: this member has not shared
                           their MINTY profile with this merchant yet, so nothing
                           is prefilled — the same rule get-profile applies for
                           the member site. Saving is what shares it. -->
                      <p class="profile-note" v-if="isLoadDone && !isPopulateData">
                        Fill in and save to share your MINTY profile with this
                        merchant.
                      </p>

                      <!-- Which fields exist, which are mandatory and which earn
                           a voucher all come from the merchant's own
                           configuration (get-profile's `fields`), so this form is
                           whatever THIS merchant asked for. -->
                      <div class="profile-form-grid" v-if="show('isNameDisplay') && show('isLastNameDisplay')">
                        <div class="profile-field">
                          <label>First Name<i v-if="req('isNameRequire')" class="profile-req">*</i><span v-if="rew('isNameReward')" class="material-icons-round profile-gift" :title="REWARD_HINT">redeem</span></label>
                          <input v-model="form.name" type="text" data-field="name" placeholder="Enter first name" />
                        </div>
                        <div class="profile-field">
                          <label>Last Name<i v-if="req('isLastNameRequire')" class="profile-req">*</i><span v-if="rew('isLastNameReward')" class="material-icons-round profile-gift" :title="REWARD_HINT">redeem</span></label>
                          <input v-model="form.last_name" type="text" data-field="last_name" placeholder="Enter last name" />
                        </div>
                      </div>
                      <template v-else>
                        <div class="profile-field" v-if="show('isNameDisplay')">
                          <label>First Name<i v-if="req('isNameRequire')" class="profile-req">*</i><span v-if="rew('isNameReward')" class="material-icons-round profile-gift" :title="REWARD_HINT">redeem</span></label>
                          <input v-model="form.name" type="text" data-field="name" placeholder="Enter first name" />
                        </div>
                        <div class="profile-field" v-if="show('isLastNameDisplay')">
                          <label>Last Name<i v-if="req('isLastNameRequire')" class="profile-req">*</i><span v-if="rew('isLastNameReward')" class="material-icons-round profile-gift" :title="REWARD_HINT">redeem</span></label>
                          <input v-model="form.last_name" type="text" data-field="last_name" placeholder="Enter last name" />
                        </div>
                      </template>

                      <div class="profile-field" v-if="show('isNRICDisplay')">
                        <label>Last 4 characters of NRIC/Passport (eg 123C)<i v-if="req('isNRICRequire')" class="profile-req">*</i><span v-if="rew('isNRICReward')" class="material-icons-round profile-gift" :title="REWARD_HINT">redeem</span></label>
                        <input v-model="form.nric" type="text" maxlength="4" data-field="nric" placeholder="123C" />
                      </div>

                      <div class="profile-field" v-if="show('isDateDisplay')">
                        <label>Date of Birth<i v-if="req('isDateRequire')" class="profile-req">*</i><span v-if="rew('isDateReward')" class="material-icons-round profile-gift" :title="REWARD_HINT">redeem</span></label>
                        <!-- MTH100: a date of birth already on record cannot be changed. It is
                        rendered as plain text because a disabled `type="date"` still follows the
                        browser locale and shows nothing at all for a `Y-m-d H:i:s` value. -->
                        <input
                          v-if="isDobLocked"
                          :value="dobDisplay"
                          type="text"
                          data-field="date_of_birth"
                          disabled
                        />
                        <input v-else v-model="form.date_of_birth" type="date" data-field="date_of_birth" />
                        <!-- Shown locked as well as unlocked: it explains why the
                             field is locked, which is exactly when a member asks. -->
                        <span class="profile-hint">
                          The day and month of your birthday (ddmm) is your
                          4-digit default passcode. It can only be changed once,
                          before any gift redemption.
                        </span>
                      </div>

                      <div class="profile-field" v-if="show('isGenderDisplay')">
                        <label>Gender<i v-if="req('isGenderRequire')" class="profile-req">*</i><span v-if="rew('isGenderReward')" class="material-icons-round profile-gift" :title="REWARD_HINT">redeem</span></label>
                        <div class="profile-choices" data-field="gender">
                          <label class="profile-choice" v-for="opt in GENDER_OPTIONS" :key="opt.value">
                            <input type="radio" name="gender" :value="opt.value" v-model="form.gender" />
                            <span>{{ opt.label }}</span>
                          </label>
                        </div>
                      </div>

                      <div class="profile-field" v-if="show('isEmailDisplay')">
                        <label>Email Address<i v-if="req('isEmailRequire')" class="profile-req">*</i><span v-if="rew('isEmailReward')" class="material-icons-round profile-gift" :title="REWARD_HINT">redeem</span></label>
                        <input v-model="form.email" type="email" data-field="email" placeholder="Enter email" />
                      </div>

                      <!-- Sits after Email because that is where the member site
                           puts it, and the two forms are read side by side. -->
                      <div class="profile-field">
                        <label>Mobile Number<i class="profile-req">*</i></label>
                        <div class="profile-phone">
                          <select
                            v-model="form.phone_code"
                            class="profile-phone-code"
                            data-field="phone_code"
                            :disabled="!phoneUnlocked"
                          >
                            <option
                              v-for="c in countryData"
                              :key="c.value"
                              :value="c.value"
                            >
                              {{ c.label }}
                            </option>
                          </select>
                          <input
                            v-model="form.phone_number"
                            type="tel"
                            inputmode="numeric"
                            data-field="phone_number"
                            :disabled="!phoneUnlocked"
                          />
                          <button
                            type="button"
                            class="profile-phone-btn"
                            :disabled="phoneButtonDisabled"
                            @click="onPhoneButton()"
                          >
                            {{ phoneButtonLabel }}
                          </button>
                        </div>

                        <!-- Inline rather than a dialog: this form already lives
                             in a modal, and stacking a second one over it is the
                             kind of thing that strands a backdrop. -->
                        <div class="profile-otp" v-if="otpSent">
                          <span class="profile-hint">
                            Enter the 4-digit code sent to +{{ form.phone_code }}
                            {{ form.phone_number }}
                          </span>
                          <div class="profile-otp-row" data-field="otp">
                            <!-- Left readable on purpose: it is a code the member has
                                 just been sent, not a secret they are choosing. -->
                            <v-otp-input
                              :key="'otp-' + keyReload"
                              input-classes="pf-otp"
                              separator=""
                              :num-inputs="4"
                              :is-input-num="true"
                              :placeholder="['', '', '', '']"
                              @on-change="form.otp = $event"
                              @on-complete="form.otp = $event"
                            />
                          </div>
                        </div>
                      </div>

                      <div class="profile-field" v-if="show('isHouseAddressDisplay')">
                        <label>Address<i v-if="req('isHouseAddressRequire')" class="profile-req">*</i><span v-if="rew('isHouseAddressReward')" class="material-icons-round profile-gift" :title="REWARD_HINT">redeem</span></label>
                        <input v-model="form.address_1" type="text" data-field="address_1" placeholder="Enter address" />
                      </div>

                      <div class="profile-field" v-if="show('isAddress2Display')">
                        <label>Address 2<i v-if="req('isAddress2Require')" class="profile-req">*</i><span v-if="rew('isAddress2Reward')" class="material-icons-round profile-gift" :title="REWARD_HINT">redeem</span></label>
                        <input v-model="form.address_2" type="text" data-field="address_2" placeholder="Enter address 2" />
                      </div>

                      <div class="profile-field" v-if="show('isPostCodeDisplay')">
                        <label>Postal Code<i v-if="req('isPostCodeRequire')" class="profile-req">*</i><span v-if="rew('isPostCodeReward')" class="material-icons-round profile-gift" :title="REWARD_HINT">redeem</span></label>
                        <input v-model="form.postal_code" type="text" data-field="postal_code" placeholder="Enter postal code" />
                      </div>

                      <div class="profile-field" v-if="show('isOccupationDisplay')">
                        <label>Occupation<i v-if="req('isOccupationRequire')" class="profile-req">*</i><span v-if="rew('isOccupationReward')" class="material-icons-round profile-gift" :title="REWARD_HINT">redeem</span></label>
                        <input v-model="form.occupation" type="text" data-field="occupation" placeholder="Enter occupation" />
                      </div>

                      <div class="profile-field" v-if="show('isMonthlyIncomeRangeDisplay')">
                        <label>Monthly Income Range<i v-if="req('isMonthlyIncomeRangeRequire')" class="profile-req">*</i><span v-if="rew('isMonthlyIncomeRangeReward')" class="material-icons-round profile-gift" :title="REWARD_HINT">redeem</span></label>
                        <div class="profile-choices profile-choices--stack" data-field="monthly_income_range">
                          <label class="profile-choice" v-for="opt in INCOME_OPTIONS" :key="opt.value">
                            <input type="radio" name="monthly_income_range" :value="opt.value" v-model="form.monthly_income_range" />
                            <span>{{ opt.label }}</span>
                          </label>
                        </div>
                      </div>

                      <div class="profile-field" v-if="show('isMaritalStatusDisplay')">
                        <label>Marital Status<i v-if="req('isMaritalStatusRequire')" class="profile-req">*</i><span v-if="rew('isMaritalStatusReward')" class="material-icons-round profile-gift" :title="REWARD_HINT">redeem</span></label>
                        <select v-model="form.marital_status" data-field="marital_status">
                          <option value="">Select Marital Status</option>
                          <option v-for="opt in MARITAL_OPTIONS" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
                        </select>
                      </div>

                      <div class="profile-field" v-if="show('isDiscoveryDisplay')">
                        <label>Discovery Channel<i v-if="req('isDiscoveryRequire')" class="profile-req">*</i><span v-if="rew('isDiscoveryReward')" class="material-icons-round profile-gift" :title="REWARD_HINT">redeem</span></label>
                        <select v-model="form.discovery_channel" data-field="discovery_channel">
                          <option value="">Select Discovery Channel</option>
                          <option v-for="opt in DISCOVERY_OPTIONS" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
                        </select>
                      </div>

                      <div class="profile-field" v-if="show('isCountryOfResidentDisplay')">
                        <label>Country Of Resident<i v-if="req('isCountryOfResidentRequire')" class="profile-req">*</i><span v-if="rew('isCountryOfResidentReward')" class="material-icons-round profile-gift" :title="REWARD_HINT">redeem</span></label>
                        <select v-model="form.country_id" data-field="country_id">
                          <option value="">Select Country Of Resident</option>
                          <option v-for="c in countries" :key="c.id" :value="c.id">{{ c.country_name }}</option>
                        </select>
                      </div>

                      <div class="profile-field" v-if="show('isEducationDisplay')">
                        <label>Education<i v-if="req('isEducationRequire')" class="profile-req">*</i><span v-if="rew('isEducationReward')" class="material-icons-round profile-gift" :title="REWARD_HINT">redeem</span></label>
                        <select v-model="form.education" data-field="education">
                          <option value="">Select Education</option>
                          <option v-for="opt in EDUCATION_OPTIONS" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
                        </select>
                      </div>

                      <div class="profile-field" v-if="show('isReceiveOffersDisplay')">
                        <label>I want to receive offers, updates and promotions by email</label>
                        <div class="profile-choices" data-field="receive_offers">
                          <label class="profile-choice">
                            <input type="radio" name="receive_offers" value="1" v-model="form.receive_offers" />
                            <span>Yes</span>
                          </label>
                          <label class="profile-choice">
                            <input type="radio" name="receive_offers" value="0" v-model="form.receive_offers" />
                            <span>No</span>
                          </label>
                        </div>
                      </div>

                      <!-- update-profile hashes this when it is exactly 4 digits
                           and ignores it otherwise, so an untouched field is a
                           no-op. MOO's own ChangePasscode screen stays the place
                           to change it deliberately; this is here because a
                           merchant can put it on the profile form. -->
                      <div class="profile-field" v-if="show('isPasscodeDisplay')">
                        <!-- Never marked required, whatever the merchant configured:
                             the field is always safe to leave blank, and a `*` beside
                             a control whose own hint says "leave blank" is a
                             contradiction the member cannot resolve. -->
                        <label>Passcode<span v-if="rew('isPasscodeReward')" class="material-icons-round profile-gift" :title="REWARD_HINT">redeem</span></label>
                        <div class="profile-otp-row" data-field="passcode">
                          <!-- v-model does nothing here: vue3-otp-input declares no
                               modelValue prop and never emits update:modelValue, it
                               only emits on-change / on-complete. Bound to those, or
                               form.passcode stays empty however many digits are typed.
                               `key` remounts it when the modal reopens, since without
                               a model there is no way to clear it from the outside. -->
                          <v-otp-input
                            :key="'pc-' + keyReload"
                            input-classes="pf-otp"
                            separator=""
                            input-type="password"
                            :num-inputs="4"
                            :is-input-num="true"
                            :placeholder="['', '', '', '']"
                            @on-change="form.passcode = $event"
                            @on-complete="form.passcode = $event"
                          />
                        </div>
                        <span class="profile-hint">{{ passcodeHint }}</span>
                      </div>

                      <!-- The merchant's own custom fields. Eight types, each
                           stored differently by update-profile — see
                           customFieldPayload() for what each one has to send. -->
                      <template v-for="field in visibleCustomFields" :key="field.id">
                        <div class="profile-field">
                          <label>
                            {{ field.field_name }}<i v-if="field.is_required" class="profile-req">*</i><span v-if="field.is_reward" class="material-icons-round profile-gift" :title="REWARD_HINT">redeem</span>
                          </label>

                          <input
                            v-if="field.is_short_anwser"
                            v-model="field.field_value"
                            type="text"
                            :data-field="customFieldKey(field)"
                          />

                          <textarea
                            v-else-if="field.is_paragraph"
                            v-model="field.field_value"
                            rows="3"
                            :data-field="customFieldKey(field)"
                          ></textarea>

                          <input
                            v-else-if="field.is_date"
                            v-model="field.field_value"
                            type="date"
                            :data-field="customFieldKey(field)"
                          />

                          <!-- Stored serialized as { hours, minutes, seconds };
                               kept in that shape so the member site's own time
                               picker can still read what MOO wrote. -->
                          <input
                            v-else-if="field.is_time"
                            :value="timeValue(field)"
                            @input="setTimeValue(field, $event.target.value)"
                            type="time"
                            :data-field="customFieldKey(field)"
                          />

                          <div
                            v-else-if="field.is_single_choice"
                            class="profile-choices profile-choices--stack"
                            :data-field="customFieldKey(field)"
                          >
                            <label class="profile-choice" v-for="opt in field.options" :key="opt.id">
                              <input
                                type="radio"
                                :name="customFieldKey(field)"
                                :value="opt.id"
                                v-model="field.field_value"
                              />
                              <span>{{ opt.name }}</span>
                            </label>
                          </div>

                          <div
                            v-else-if="field.is_multiple_choice"
                            class="profile-choices profile-choices--stack"
                            :data-field="customFieldKey(field)"
                          >
                            <label class="profile-choice" v-for="opt in field.options" :key="opt.id">
                              <input
                                type="checkbox"
                                :checked="isChecked(field, opt)"
                                @change="toggleChoice(field, opt)"
                              />
                              <span>{{ opt.name }}</span>
                            </label>
                          </div>

                          <select
                            v-else-if="field.is_dropdown_list"
                            v-model="field.field_value"
                            :data-field="customFieldKey(field)"
                          >
                            <option :value="0">Select</option>
                            <option v-for="opt in field.options" :key="opt.value" :value="opt.value">
                              {{ opt.label }}
                            </option>
                          </select>

                          <div v-else-if="field.is_file_upload" :data-field="customFieldKey(field)">
                            <input
                              :ref="'file_' + field.id"
                              type="file"
                              class="profile-file-input"
                              accept="image/png,image/jpeg,image/jpg,image/svg+xml"
                              @change="onFilePicked($event, field)"
                            />
                            <div class="profile-file">
                              <button type="button" class="profile-file-btn" @click="pickFile(field)">
                                Upload file
                              </button>
                              <span class="profile-hint">Image up to 2MB</span>
                            </div>
                            <div class="profile-file-preview" v-if="filePreview(field)">
                              <img :src="filePreview(field)" alt="" />
                              <button type="button" class="profile-file-clear" @click="clearFile(field)">
                                <span class="material-icons-round">close</span>
                              </button>
                            </div>
                          </div>

                          <input
                            v-else
                            v-model="field.field_value"
                            type="text"
                            :data-field="customFieldKey(field)"
                          />
                        </div>
                      </template>

                      <!-- Saving with a reward field still empty forfeits the
                           voucher, and the merchant's gate is one-shot — so say
                           so before the member taps Save, not after. -->
                      <p class="profile-note profile-note--reward" v-if="hasUnfilledRewardField">
                        <span class="material-icons-round">redeem</span>
                        Some fields marked
                        <span class="material-icons-round profile-gift">redeem</span>
                        are still empty. Fill them in to earn your reward voucher.
                      </p>

                      <button
                        class="profile-save-btn"
                        type="button"
                        :disabled="isLoading"
                        @click="updateMemberInfo"
                      >
                        Save Changes
                      </button>
                    </section>
                  </div>
                </div>
              </div>
            </div>
            <material-loading :active="loaderActive" />
          </div>
        </div>
      </div>
    </div>
    <div class="position-fixed top-1 end-1 z-index-2 message-success" style="z-index: 99999 !important;">
      <material-snackbar
      v-if="snackbar === 'danger' || snackbar === 'success'"
      title=""
      date=""
      :description="message"
      :icon="{ component: 'campaign', color: 'white' }"
      :color="snackbar"
      :close-handler="closeSnackbar"
      />
  </div>
  </div>
</template>

<script>
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import MaterialLoading from "@/components/MaterialLoading.vue";
import VOtpInput from "vue3-otp-input";
import MemberAuthService from "../../services/memberAuth.service";
import $ from "jquery";
import { localStorageName, scrollToFirstInvalid } from "@/config/utils";
import "bootstrap/dist/js/bootstrap.bundle";
import MemberService from "../../services/member.service";
import moment from "moment";

// Rendered `disabled` above, so they can be jumped to but not focused.
const READONLY_PROFILE_FIELDS = ["phone_code", "phone_number"];

const REWARD_HINT = "Fill in this field to get reward!";

// Option lists the member site hardcodes in its own profile form; the stored
// values are the ids, so these have to stay in step with it.
const GENDER_OPTIONS = [
  { value: "1", label: "Male" },
  { value: "2", label: "Female" },
];
const INCOME_OPTIONS = [
  { value: "1", label: "$0 - $3,000" },
  { value: "2", label: "$3,001 - $6,000" },
  { value: "3", label: "$6,001 - $9,000" },
  { value: "4", label: "Above $9,000" },
];
const MARITAL_OPTIONS = [
  { value: "1", label: "Married" },
  { value: "2", label: "Single" },
];
const DISCOVERY_OPTIONS = [
  { value: "1", label: "Social Media" },
  { value: "2", label: "Traditional Media" },
  { value: "3", label: "Word of Mouth" },
  { value: "4", label: "Events" },
  { value: "5", label: "Others" },
];
const EDUCATION_OPTIONS = [
  { value: "1", label: "Secondary" },
  { value: "2", label: "Tertiary Education" },
  { value: "3", label: "Bachelor" },
  { value: "4", label: "Postgraduate" },
];

// MintyMember::DEFAULT_PHONE_CODE and the length MemberProfileRequest enforces
// for it; other countries only need enough digits to be plausible.
const SG_PHONE_CODE = "65";
const SG_PHONE_LENGTH = 8;
const MIN_PHONE_LENGTH = 6;
const OTP_LENGTH = 4;
// Same window the member site puts between one OTP and the next.
const OTP_RESEND_SECONDS = 45;

const MAX_UPLOAD_BYTES = 2 * 1024 * 1024;
const ALLOWED_UPLOAD_TYPES = [
  "image/png",
  "image/jpg",
  "image/jpeg",
  "image/svg+xml",
];

// Validated in this order, so the message and the field the page scrolls to are
// the same ones the member site reports. `key` is what `data-field` carries.
const VALIDATION_ORDER = [
  { key: "name", label: "First Name", display: "isNameDisplay", require: "isNameRequire", reward: "isNameReward" },
  { key: "last_name", label: "Last Name", display: "isLastNameDisplay", require: "isLastNameRequire", reward: "isLastNameReward" },
  { key: "nric", label: "NRIC/Passport", display: "isNRICDisplay", require: "isNRICRequire", reward: "isNRICReward" },
  { key: "date_of_birth", label: "Date of Birth", display: "isDateDisplay", require: "isDateRequire", reward: "isDateReward" },
  { key: "gender", label: "Gender", display: "isGenderDisplay", require: "isGenderRequire", reward: "isGenderReward" },
  { key: "email", label: "Email Address", display: "isEmailDisplay", require: "isEmailRequire", reward: "isEmailReward" },
  { key: "address_1", label: "Address", display: "isHouseAddressDisplay", require: "isHouseAddressRequire", reward: "isHouseAddressReward" },
  { key: "address_2", label: "Address 2", display: "isAddress2Display", require: "isAddress2Require", reward: "isAddress2Reward" },
  { key: "postal_code", label: "Postal Code", display: "isPostCodeDisplay", require: "isPostCodeRequire", reward: "isPostCodeReward" },
  { key: "occupation", label: "Occupation", display: "isOccupationDisplay", require: "isOccupationRequire", reward: "isOccupationReward" },
  { key: "monthly_income_range", label: "Monthly Income Range", display: "isMonthlyIncomeRangeDisplay", require: "isMonthlyIncomeRangeRequire", reward: "isMonthlyIncomeRangeReward" },
  { key: "marital_status", label: "Marital Status", display: "isMaritalStatusDisplay", require: "isMaritalStatusRequire", reward: "isMaritalStatusReward" },
  { key: "discovery_channel", label: "Discovery Channel", display: "isDiscoveryDisplay", require: "isDiscoveryRequire", reward: "isDiscoveryReward" },
  { key: "country_id", label: "Country Of Resident", display: "isCountryOfResidentDisplay", require: "isCountryOfResidentRequire", reward: "isCountryOfResidentReward" },
  { key: "education", label: "Education", display: "isEducationDisplay", require: "isEducationRequire", reward: "isEducationReward" },
];

const EMAIL_PATTERN = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,64}$/i;

const emptyForm = () => ({
  name: "",
  last_name: "",
  nric: "",
  date_of_birth: "",
  gender: "",
  email: "",
  phone_code: "",
  phone_number: "",
  address_1: "",
  address_2: "",
  postal_code: "",
  occupation: "",
  monthly_income_range: "",
  marital_status: "",
  discovery_channel: "",
  country_id: "",
  education: "",
  receive_offers: "0",
  // Only sent when the number is actually changing — see buildPayload().
  otp: "",
  // Never prefilled — it is stored hashed and does not round-trip. Blank means
  // "keep the current one", which is how update-profile reads it.
  passcode: "",
});

export default {
  name: "Item Detail",
  components: {
    MaterialLoading,
    MaterialSnackbar,
    VOtpInput
  },
  props: {
    member: {
      type: Object,
      required: true,
    },
    keyReload: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      snackbar: null,
      message: "",
      isLoadDone: false,
      loaderActive: false,
      isLoading: false,
      merchantCode: "",
      branchCode: "",
      branch: JSON.parse(
        localStorage.getItem(localStorageName("BRANCH_INFO"), "")
      ),
      messError: null,
      form: emptyForm(),
      // The merchant's field configuration, from get-profile. Empty until it
      // lands, which is why every lookup goes through show()/req()/rew().
      displayFields: {},
      required: {},
      reward: {},
      // The merchant's own custom fields, edited in place.
      customFields: [],
      // false when the member has not shared their MINTY profile with this
      // merchant yet: nothing is prefilled, same as the member site.
      isPopulateData: true,
      // Off the member row, not the form: a first-time member picking a date
      // must not lock the field before saving.
      dobOnRecord: "",
      countryData: [],
      countries: [],
      // Whether this member already has a passcode. The field never round-trips
      // (it is stored hashed), so "required" can only mean "must have one", not
      // "must retype it on every save".
      hasPasscode: false,
      // --- changing the mobile number ---
      // Locked until the member asks, so the field cannot be edited by accident
      // on a form they opened to change something else.
      phoneUnlocked: false,
      otpSent: false,
      otpCountdown: 0,
      otpTimer: null,
      phoneNumberOld: "",
      phoneCodeOld: "",
      REWARD_HINT,
      GENDER_OPTIONS,
      INCOME_OPTIONS,
      MARITAL_OPTIONS,
      DISCOVERY_OPTIONS,
      EDUCATION_OPTIONS,
    };
  },
  async created() {
    this.cartName = await this.$store.dispatch("cartName");
    this.merchantCode = this.$store.state.merchantCode;
  },
  async mounted() {
    this._popstateHandler = () => this.closeModel(true);
    window.addEventListener("popstate", this._popstateHandler);
  },
  beforeUnmount() {
    window.removeEventListener("popstate", this._popstateHandler);
    this.stopOtpCountdown();
    this.closeModel();
  },
  computed: {
    styleObject() {
      return {
        "--color": this.$store.state.mainThemeColorTheme2
          ? this.$store.state.mainThemeColorTheme2
          : this.$store.state.color,
      };
    },
    isDobLocked() {
      return !!this.dobOnRecord;
    },
    dobDisplay() {
      return this.dobOnRecord
        ? moment(this.dobOnRecord).format("DD-MM-YYYY")
        : "";
    },
    visibleCustomFields() {
      return this.customFields.filter((field) => field.is_display == 1);
    },
    // "Leave blank to keep your current passcode" is only true for a member who
    // has one; for anyone else it describes something that does not exist.
    passcodeHint() {
      return this.hasPasscode
        ? "Leave blank to keep your current passcode."
        : "Optional. Set a 4-digit passcode, or leave blank.";
    },
    phoneChanged() {
      return (
        this.form.phone_number != this.phoneNumberOld ||
        this.form.phone_code != this.phoneCodeOld
      );
    },
    phoneLengthOk() {
      const value = String(this.form.phone_number || "");
      return this.form.phone_code == SG_PHONE_CODE
        ? value.length == SG_PHONE_LENGTH
        : value.length >= MIN_PHONE_LENGTH;
    },
    phoneButtonLabel() {
      if (!this.phoneUnlocked) {
        return "Change";
      }
      if (this.otpCountdown > 0) {
        return this.otpCountdown + "s";
      }
      return this.otpSent ? "Resend" : "Get OTP";
    },
    phoneButtonDisabled() {
      if (!this.phoneUnlocked) {
        return false;
      }
      return this.otpCountdown > 0 || !this.phoneChanged || !this.phoneLengthOk;
    },
    // A field the merchant attached a voucher to that the member has left empty.
    // The voucher is granted once and never revisited, so leaving it empty
    // forfeits it silently — worth saying before the save, not after.
    hasUnfilledRewardField() {
      if (!this.isLoadDone) {
        return false;
      }
      const missing = VALIDATION_ORDER.some(
        (f) => this.show(f.display) && this.rew(f.reward) && this.isBlank(this.form[f.key])
      );
      return (
        missing ||
        this.visibleCustomFields.some(
          (field) => field.is_reward == 1 && this.isBlank(field.field_value)
        )
      );
    },
  },
  methods: {
    show(key) {
      return !!this.displayFields[key];
    },
    req(key) {
      return !!this.required[key];
    },
    rew(key) {
      return !!this.reward[key];
    },
    isBlank(value) {
      if (value === null || value === undefined || value === false) {
        return true;
      }
      if (Array.isArray(value)) {
        return value.length === 0;
      }
      if (typeof value === "object") {
        return false;
      }
      return String(value).trim() === "" || String(value) === "0";
    },
    customFieldKey(field) {
      return field.field_name_convert || "custom_" + field.id;
    },
    async initializeData() {
      // Previews are object URLs; they outlive the reset otherwise.
      this.customFields.forEach((field) => {
        if (field.field_value_preview) {
          URL.revokeObjectURL(field.field_value_preview);
        }
      });
      this.form = emptyForm();
      this.displayFields = {};
      this.required = {};
      this.reward = {};
      this.customFields = [];
      this.isPopulateData = true;
      this.dobOnRecord = "";
      this.countryData = [];
      this.countries = [];
      this.hasPasscode = false;
      this.stopOtpCountdown();
      this.phoneUnlocked = false;
      this.otpSent = false;
      this.phoneNumberOld = "";
      this.phoneCodeOld = "";
      this.isLoadDone = false;
      this.isLoading = false;
      this.message = "";
      this.snackbar = null;

      this.showLoader();
      await Promise.all([this.getCountryDropdown(), this.getProfile()]);
      // Only the merchants that ask for it need the country list.
      if (this.show("isCountryOfResidentDisplay")) {
        await this.getCountries();
      }
      this.isLoadDone = true;
      this.hideLoader();
    },
    async getProfile() {
      try {
        const response = await MemberService.getProfile();
        if (!response.data.result.isSuccess) {
          this.snackbar = "danger";
          this.message = response.data.result.message;
          this.setTimeOutNotification();
          return;
        }

        const data = response.data.data ?? {};
        const fields = data.fields ?? {};
        this.displayFields = fields.isDisplay ?? {};
        this.required = fields.isRequired ?? {};
        this.reward = fields.isReward ?? {};
        this.customFields = data.fields_another ?? [];
        this.isPopulateData = data.is_populate_data !== false;
        // Falls back to the member row this modal was opened with: if the read
        // above is missing the value for any reason, an unlocked date field
        // would let a member overwrite a birthday that cannot be changed twice.
        this.dobOnRecord = data.date_of_birth || this.member.date_of_birth || "";

        // Contact details are prefilled either way — the member site does the
        // same, and the phone pair is read-only here anyway.
        this.form.email = data.email || "";
        this.form.phone_code = data.phone_code || "";
        this.form.phone_number = data.phone_number || "";
        this.phoneCodeOld = this.form.phone_code;
        this.phoneNumberOld = this.form.phone_number;
        this.hasPasscode = !!data.has_passcode;

        if (this.isPopulateData) {
          this.form.name = data.name || "";
          this.form.last_name = data.last_name || "";
          this.form.nric = data.nric || "";
          this.form.date_of_birth = data.date_of_birth || "";
          this.form.gender = data.gender ? String(data.gender) : "";
          this.form.address_1 = data.address_1 || "";
          this.form.address_2 = data.address_2 || "";
          this.form.postal_code = data.postal_code || "";
          this.form.occupation = data.occupation || "";
          this.form.monthly_income_range = data.monthly_income_range
            ? String(data.monthly_income_range)
            : "";
          this.form.marital_status = data.marital_status
            ? String(data.marital_status)
            : "";
          this.form.discovery_channel = data.discovery_channel
            ? String(data.discovery_channel)
            : "";
          this.form.country_id = data.country_id || "";
          this.form.education = data.education ? String(data.education) : "";
          this.form.receive_offers = String(data.receive_offers ?? 0);
        } else {
          // Not shared yet: the custom fields carry values too, so they are
          // blanked for the same reason the rest is not prefilled.
          this.customFields = this.customFields.map((field) => ({
            ...field,
            field_value: field.is_dropdown_list ? 0 : "",
          }));
        }
      } catch (error) {
        this.snackbar = "danger";
        this.message =
          error?.response?.data?.result?.message ?? "Cannot load profile";
        this.setTimeOutNotification();
      }
    },
    async getCountryDropdown() {
      try {
        const response = await MemberService.getCountryDropdown();
        if (response.data.result.isSuccess) {
          this.countryData = response.data.data ?? [];
        }
      } catch (error) {
        // The phone pair is read-only; a missing code list costs the member
        // nothing they can act on, so it stays quiet rather than stacking a
        // second error over the one that matters.
      }
    },
    async getCountries() {
      try {
        const response = await MemberService.getCountries();
        if (response.data.result.isSuccess) {
          this.countries = response.data.data ?? [];
        }
      } catch (error) {
        this.snackbar = "danger";
        this.message = "Cannot load countries";
        this.setTimeOutNotification();
      }
    },
    // Stored serialized as { hours, minutes, seconds } by update-profile, which
    // is what the member site's time picker reads back. Kept in that shape so
    // both apps can edit the same field.
    timeValue(field) {
      const value = field.field_value;
      if (!value || typeof value !== "object") {
        return "";
      }
      const pad = (n) => String(n ?? 0).padStart(2, "0");
      return pad(value.hours) + ":" + pad(value.minutes);
    },
    setTimeValue(field, value) {
      if (!value) {
        field.field_value = "";
        return;
      }
      const [hours, minutes] = value.split(":");
      field.field_value = {
        hours: Number(hours) || 0,
        minutes: Number(minutes) || 0,
        seconds: 0,
      };
    },
    isChecked(field, option) {
      return (
        Array.isArray(field.field_value) &&
        field.field_value.includes(option.id)
      );
    },
    toggleChoice(field, option) {
      if (!Array.isArray(field.field_value)) {
        field.field_value = [];
      }
      const index = field.field_value.indexOf(option.id);
      if (index > -1) {
        field.field_value.splice(index, 1);
      } else {
        field.field_value.push(option.id);
      }
    },
    // Three states in one button, the same shape the member site uses: Change
    // unlocks the field, Get OTP sends the code, then a 45s countdown before a
    // resend is allowed.
    onPhoneButton() {
      if (!this.phoneUnlocked) {
        this.phoneUnlocked = true;
        return;
      }
      this.sendProfileOtp();
    },
    sendProfileOtp() {
      this.showLoader();
      MemberAuthService.sendOtp({
        phone_number: this.form.phone_number,
        phone_code: this.form.phone_code,
        is_profile: 1,
      }).then(
        (data) => {
          if (data && data.result && !data.result.isSuccess) {
            this.snackbar = "danger";
            this.message = data.result.message;
            this.setTimeOutNotification();
            this.hideLoader();
            return;
          }
          this.otpSent = true;
          this.form.otp = "";
          this.startOtpCountdown();
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message =
            error?.response?.data?.result?.message ?? "Cannot send OTP";
          this.setTimeOutNotification();
          this.hideLoader();
        }
      );
    },
    startOtpCountdown() {
      this.stopOtpCountdown();
      this.otpCountdown = OTP_RESEND_SECONDS;
      this.otpTimer = setInterval(() => {
        this.otpCountdown -= 1;
        if (this.otpCountdown <= 0) {
          this.stopOtpCountdown();
        }
      }, 1000);
    },
    stopOtpCountdown() {
      if (this.otpTimer) {
        clearInterval(this.otpTimer);
        this.otpTimer = null;
      }
      this.otpCountdown = 0;
    },
    pickFile(field) {
      const input = this.$refs["file_" + field.id];
      const element = Array.isArray(input) ? input[0] : input;
      if (element) {
        element.click();
      }
    },
    onFilePicked(event, field) {
      const file = event.target.files && event.target.files[0];
      if (!file) {
        return;
      }
      if (!ALLOWED_UPLOAD_TYPES.includes(file.type)) {
        this.snackbar = "danger";
        this.message = "File must be an image";
        this.setTimeOutNotification();
        event.target.value = "";
        return;
      }
      if (file.size > MAX_UPLOAD_BYTES) {
        this.snackbar = "danger";
        this.message = "Image must be 2MB or smaller";
        this.setTimeOutNotification();
        event.target.value = "";
        return;
      }
      field.field_value = file;
      field.field_value_preview = URL.createObjectURL(file);
      field.isDelete = 1;
    },
    clearFile(field) {
      if (field.field_value_preview) {
        URL.revokeObjectURL(field.field_value_preview);
        field.field_value_preview = "";
      }
      field.field_value = "";
      // 2 is what update-profile reads as "delete the stored file".
      field.isDelete = 2;
    },
    filePreview(field) {
      // field_value is the uploaded File once picked; until then it is the URL
      // get-profile returned for what is already stored.
      return (
        field.field_value_preview ||
        (typeof field.field_value === "string" ? field.field_value : "")
      );
    },
    // M899: the message alone lands in a corner toast that says nothing about
    // which field is empty, so the field is reported with it.
    validateForm() {
      for (const field of VALIDATION_ORDER) {
        if (!this.show(field.display)) {
          continue;
        }
        // A date of birth already on record is not editable and is not sent, so
        // requiring it again would be an error the member cannot clear.
        if (field.key === "date_of_birth" && this.isDobLocked) {
          continue;
        }
        if (this.req(field.require) && this.isBlank(this.form[field.key])) {
          return { message: field.label + " is required", field: field.key };
        }
      }

      if (this.show("isEmailDisplay") && this.form.email) {
        if (!EMAIL_PATTERN.test(this.form.email)) {
          return {
            message: "The email must be a valid email address",
            field: "email",
          };
        }
      }

      if (!this.form.phone_number) {
        return { message: "Mobile number is required", field: "phone_number" };
      }

      if (this.phoneChanged) {
        if (!this.phoneLengthOk) {
          return {
            message:
              this.form.phone_code == SG_PHONE_CODE
                ? "Mobile number must be " + SG_PHONE_LENGTH + " digits"
                : "Mobile number is not valid",
            field: "phone_number",
          };
        }
        // updateProfile only verifies the OTP when the number moves, so this is
        // the same condition on the client.
        if (String(this.form.otp || "").length != OTP_LENGTH) {
          return {
            message: this.otpSent
              ? "Enter the 4-digit code we sent you"
              : "Tap Get OTP to verify your new number",
            field: this.otpSent ? "otp" : "phone_number",
          };
        }
      }

      // Passcode is deliberately NOT validated, even when the merchant marked it
      // required. The stored value is hashed and never comes back, so the input
      // is empty on every load — enforcing it would demand four digits on every
      // save of any other field, and it would contradict the field's own hint.
      // Blank means "keep what you have".

      for (const field of this.visibleCustomFields) {
        if (field.is_required == 1 && this.isBlank(field.field_value)) {
          return {
            message: field.field_name + " is required",
            field: this.customFieldKey(field),
          };
        }
      }

      return { message: "", field: "" };
    },
    // Only what update-profile actually reads off each custom field. Sending the
    // whole row back would push `options`, previews and the resolved asset URL
    // through the request for nothing.
    customFieldPayload() {
      return this.visibleCustomFields.map((field) => {
        // get-profile returns `false` for a time / multiple-choice field whose
        // stored value is empty, because that is what PHP's unserialize('')
        // gives. FormData would send that as the STRING "false", which the BE
        // reads as a real value and serialises back — so it is normalised to the
        // empty string the BE understands as "not answered".
        const raw = field.field_value;
        const entry = {
          id: field.id,
          field_value: raw === false || raw === null || raw === undefined ? "" : raw,
        };
        if (field.is_time) {
          entry.is_time = 1;
        }
        if (field.is_multiple_choice) {
          entry.is_multiple_choice = 1;
        }
        if (field.is_file_upload) {
          entry.is_file_upload = 1;
          // update-profile nulls the stored value for ANY empty field_value, so
          // an untouched upload must send back the URL get-profile gave it: a
          // non-empty value that is not an UploadedFile makes the BE keep the
          // stored filename. Sending "" here would wipe the member's file.
          if (field.isDelete === 2) {
            entry.field_value = "";
            entry.isDelete = 2;
            if (field.path_image) {
              entry.path_image = field.path_image;
            }
          } else if (field.field_value instanceof File) {
            entry.isDelete = 1;
          }
        }
        return entry;
      });
    },
    buildPayload() {
      const payload = { ...this.form, id: this.member.id };

      // Only sent when it actually moves: MemberProfileRequest skips its phone
      // rules when the values match what is on record anyway, and updateProfile
      // only asks for an OTP on a real change. Sending them unchanged on every
      // save would just be noise.
      if (!this.phoneChanged) {
        delete payload.phone_number;
        delete payload.phone_code;
        delete payload.otp;
      }

      // Locked: the stored value stands, and sending the `Y-m-d H:i:s` string
      // back through a date field would only risk rewriting it.
      if (this.isDobLocked) {
        delete payload.date_of_birth;
      }

      if (payload.nric) {
        payload.nric = String(payload.nric).toUpperCase();
      }

      // Not asked for on this screen. Passcode has its own screen in MOO, and
      // deactivating an account from an ordering app is not something we offer.
      payload.fields_another = this.customFieldPayload();

      return payload;
    },
    updateMemberInfo() {
      this.isLoading = true;
      const invalid = this.validateForm();
      if (invalid.message) {
        this.snackbar = "danger";
        this.message = invalid.message;
        this.setTimeOutNotification();
        this.isLoading = false;
        scrollToFirstInvalid({
          selector: `[data-field="${invalid.field}"]`,
          // The phone pair is read-only in this modal — it can only be changed
          // from the member account — so it is ringed instead of focused.
          // The phone pair is only un-focusable while it is still locked; once
          // the member has tapped Change it takes focus like any other field.
          highlight:
            !this.phoneUnlocked && READONLY_PROFILE_FIELDS.includes(invalid.field)
              ? '.profile-field'
              : null,
        });
        return;
      }

      this.showLoader();
      MemberService.updateMemberProfile(this.buildPayload()).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.phoneNumberOld = this.form.phone_number;
            this.phoneCodeOld = this.form.phone_code;
            this.stopOtpCountdown();
            this.phoneUnlocked = false;
            this.otpSent = false;
            this.form.otp = "";
            this.$emit('update-success');
            this.snackbar = "success";
            this.message = "Update info successfully";
            this.closeModel();
            this.setTimeOutNotification();
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.isLoading = false;
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message =
            error?.response?.data?.result?.message ?? "Update failed";
          this.setTimeOutNotification();
          this.isLoading = false;
          this.hideLoader();
        }
      );
    },

    formatPrice(price) {
      return "$ " + parseFloat(price).toFixed(2);
    },
    closeModel() {
      $(".btn-hide-update-profile-modal").click();
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },

    calculateAge() {
      if (!this.form.date_of_birth) return '';
      const today = new Date();
      const birthDate = new Date(this.form.date_of_birth);
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();

      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return 'Age: ' + age;
    },
    chineseZodiac() {
      if (!this.form.date_of_birth) return '';
      const zodiacSigns = ['Rat', 'Ox', 'Tiger', 'Rabbit', 'Dragon', 'Snake', 'Horse', 'Goat', 'Monkey', 'Rooster', 'Dog', 'Pig'];
      const birthYear = new Date(this.form.date_of_birth).getFullYear();
      return 'Year of ' + zodiacSigns[(birthYear - 4) % 12];
    },
    horoscope() {
      if (!this.form.date_of_birth) return '';
      const birthDate = new Date(this.form.date_of_birth);
      const month = birthDate.getMonth() + 1;
      const day = birthDate.getDate();

      if ((month === 3 && day >= 21) || (month === 4 && day <= 19)) return 'Aries';
      if ((month === 4 && day >= 20) || (month === 5 && day <= 20)) return 'Taurus';
      if ((month === 5 && day >= 21) || (month === 6 && day <= 20)) return 'Gemini';
      if ((month === 6 && day >= 21) || (month === 7 && day <= 22)) return 'Cancer';
      if ((month === 7 && day >= 23) || (month === 8 && day <= 22)) return 'Leo';
      if ((month === 8 && day >= 23) || (month === 9 && day <= 22)) return 'Virgo';
      if ((month === 9 && day >= 23) || (month === 10 && day <= 22)) return 'Libra';
      if ((month === 10 && day >= 23) || (month === 11 && day <= 21)) return 'Scorpio';
      if ((month === 11 && day >= 22) || (month === 12 && day <= 21)) return 'Sagittarius';
      if ((month === 12 && day >= 22) || (month === 1 && day <= 19)) return 'Capricorn';
      if ((month === 1 && day >= 20) || (month === 2 && day <= 18)) return 'Aquarius';
      return 'Pisces';
    },
  },
  watch: {
    keyReload: {
      handler() {
        this.initializeData();
      }
    }
  },
};
</script>

<style scoped>
/* Full Screen */
/* MTH056: hai thứ ăn mất bề rộng bên phải và làm popup lệch:
   1. Modal._adjustDialog() của Bootstrap gán padding-left/right inline lên .modal
      để bù thanh cuộn;
   2. bản thân .modal là scroll container (overflow-y:auto) nên khi nội dung tràn
      sẽ mọc thanh cuộn riêng.
   Ép padding về 0 và tắt overflow để triệt cả hai. */
.modal.modal-full {
  padding-left: 0 !important;
  padding-right: 0 !important;
  overflow: hidden;
}

/* MTH056: neo dialog theo viewport rồi dùng padding thay cho margin:auto.
   Khe hai bên bằng nhau về mặt hình học, không phụ thuộc bề rộng content box
   của .modal nên miễn nhiễm với padding chèn thêm lẫn thanh cuộn. */
.modal.modal-full .modal-dialog {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: auto;
  max-width: none;
  height: auto;
  margin: 0;
  /* MTH056: 20px = padding ngang của .reward-sheet bên MyReward.vue,
     để mép popup thẳng hàng với các card của trang */
  padding: 20px;
  /* MTH056: căn giữa popup theo chiều dọc */
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-header {
  padding: 1.2rem 1rem;
  border-bottom: unset;
}

.modal.modal-full .modal-content {
  /* MTH056: min() để min-height không thắng max-height trên màn hình thấp */
  min-height: min(400px, 100%);
  /* MTH056: nội dung dài vẫn scroll bên trong, không tràn khỏi viewport */
  max-height: 100%;
  width: 100%;
  /* MTH056: 440px = 480px (max-width .reward-sheet) - 2*20px padding,
     tức đúng bề rộng card của trang */
  max-width: 440px;
  /* MTH056: dịch toàn bộ popup sang trái 5px theo yêu cầu.
     Đặt ở .modal-content chứ không phải .modal-dialog vì dialog đã dùng
     transform: scale() cho hiệu ứng fade, sẽ ghi đè mất translateX. */
  transform: translateX(-5px);
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
}

.modal.modal-full .modal-content .modal-body {
  overflow-y: auto;
  overflow-x: hidden;
}

.modal.modal-full .close-modal {
  position: fixed;
  top: 0;
  right: 3rem;
}

.modal.modal-full.fade .modal-dialog {
  visibility: hidden;
  opacity: 0;
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  backface-visibility: hidden;
  transition: opacity 0.5s ease, visibility 0s 0.5s;
}

.modal.modal-full.fade.show .modal-dialog {
  visibility: visible;
  -webkit-transform: scale(1);
  -ms-transform: scale(1);
  transform: scale(1);
  opacity: 1;
  transition: opacity 0.5s ease, visibility 0s;
}

.modal.modal-full.fade .modal-dialog {
  bottom: 0;
  -webkit-transform: scale(0.7);
  -ms-transform: scale(0.7);
  transform: scale(0.7);
  opacity: 0;
  -webkit-transition: all 0.15s;
  transition: all 0.15s;
}

.btn-close-modal {
  position: absolute;
  background-color: #f8f8f8;
  right: 10px;
  top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  opacity: 1;
  cursor: pointer;
  z-index: 999999;
}

.btn-close-modal div {
  font-size: 32px !important;
  font-weight: bold;
  color: var(--color) !important;
  padding-right: 0 !important;
  margin-bottom: 4.5px;
}

/* CSS item detail */
.page-header {
  position: relative;
  background: #ffffff;
  height: unset !important;
  overflow-y: unset !important;
  padding-bottom: 0 !important;
}

.page-header .container {
  padding: 0 !important;
}

.break-line {
  width: auto;
  height: 8px;
  background-color: #f1f1f1;
  margin-left: 1em;
  margin-right: 1em;
}

.fs-18 {
  font-size: 16px !important;
}

.fs-16 {
  font-size: 16px !important;
}

.fs-11 {
  font-size: 11px !important;
}

.select-min {
  font-weight: 500;
  color: #eb2f06 !important;
}

.disabled-item {
  opacity: 0.5;
}
.font-inter {
  font-family: "Inter", sans-serif;
  color: #666666;
}

.font-inter-and-selected {
  font-family: "Inter", sans-serif;
  font-weight: bold;
  color: #666666;
}
.font-inter-and-not-selected {
  font-family: "Inter", sans-serif;
  font-weight: normal;
  color: #666666 !important;
  /* font-weight: '400' */
}

.icon-check {
  display: inline-block;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
  background-image: url("~@/assets/img/my-cart/icon-check-green.svg");
  width: 16px;
  height: 16px;
}

.pad-left-right {
  padding-left: 16px;
  padding-right: 16px;
}

.modal-body::-webkit-scrollbar {
  width: 5px;
}
.modal-body::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.modal-body::-webkit-scrollbar-thumb {
  background: #888;
}
.modal-body::-webkit-scrollbar-thumb:hover {
  background: #555;
}
@keyframes zoomOut {
  0% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
@media (max-width: 480px) {
  .image-container {
    width: 100%;
    height: auto;
    aspect-ratio: 1 / 1;
  }
}
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}
.popup-content {
  width: 200px;
  background: white;
  overflow-x: auto;
}

/* Match Profile.vue's "Personal Information" card look — see [[mth039-profile-reskin]] */
.moo-update-profile-modal {
  --pf: var(--color);
  --pf-06: color-mix(in srgb, var(--color) 6%, #ffffff);
  --pf-muted: color-mix(in srgb, var(--color) 50%, #ffffff);
  font-family: "Plus Jakarta Sans", "Manrope", system-ui, sans-serif;
}
.moo-update-profile-modal .profile-form-card {
  background: #ffffff;
  border-radius: 20px;
}
.moo-update-profile-modal .profile-form-title {
  margin: 0 0 14px;
  font-weight: 800;
  font-size: 1rem;
  color: #1a1c1a;
}
.moo-update-profile-modal .profile-form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 12px;
}
.moo-update-profile-modal .profile-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 12px;
}
.moo-update-profile-modal .profile-form-grid .profile-field {
  margin-bottom: 0;
}
.moo-update-profile-modal .profile-field > label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--pf-muted);
  padding-left: 2px;
}
.moo-update-profile-modal .profile-field input,
.moo-update-profile-modal .profile-field select {
  width: 100%;
  border: none;
  border-radius: 12px;
  background: var(--pf-06);
  padding: 12px 14px;
  font-size: 15px;
  color: #1a1c1a;
  outline: none;
  transition: box-shadow 0.15s ease;
}
.moo-update-profile-modal .profile-field input:focus,
.moo-update-profile-modal .profile-field select:focus {
  box-shadow: 0 0 0 2px var(--pf);
}
.moo-update-profile-modal .profile-field input:disabled,
.moo-update-profile-modal .profile-field select:disabled {
  color: #9a9a9a;
  cursor: not-allowed;
}
.moo-update-profile-modal .profile-phone {
  display: flex;
  gap: 8px;
}
.moo-update-profile-modal .profile-phone .profile-phone-code {
  flex: 0 0 92px;
  width: 92px;
}
.moo-update-profile-modal .profile-phone input {
  flex: 1;
}
.moo-update-profile-modal .profile-save-btn {
  width: 100%;
  margin-top: 4px;
  padding: 13px 16px;
  border: none;
  border-radius: 9999px;
  background: var(--pf);
  color: #ffffff;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  cursor: pointer;
  box-shadow: 0 8px 16px rgba(25, 28, 30, 0.12);
  transition: transform 0.15s ease;
}
.moo-update-profile-modal .profile-save-btn:active {
  transform: scale(0.98);
}
.moo-update-profile-modal .profile-save-btn:disabled {
  opacity: 0.6;
  cursor: progress;
}

/* --- merchant-configured fields --- */
.moo-update-profile-modal .profile-field > label {
  display: flex;
  align-items: center;
  gap: 4px;
}
.moo-update-profile-modal .profile-req {
  font-style: normal;
  color: #c0392b;
}
/* Marks a field the merchant pays a voucher for. Sized to the uppercase label
   beside it rather than inheriting the 11px label size, which rendered the
   glyph too small to read as a gift. */
.moo-update-profile-modal .profile-gift {
  font-size: 14px;
  line-height: 1;
  color: var(--pf);
}
.moo-update-profile-modal .profile-field textarea {
  width: 100%;
  border: none;
  border-radius: 12px;
  background: var(--pf-06);
  padding: 12px 14px;
  font-size: 15px;
  color: #1a1c1a;
  outline: none;
  resize: vertical;
  font-family: inherit;
}
.moo-update-profile-modal .profile-field textarea:focus {
  box-shadow: 0 0 0 2px var(--pf);
}
.moo-update-profile-modal .profile-hint {
  font-size: 11.5px;
  line-height: 1.45;
  color: #8a8a8a;
  text-transform: none;
  letter-spacing: 0;
}
.moo-update-profile-modal .profile-note {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin: 0 0 14px;
  padding: 10px 12px;
  border-radius: 12px;
  background: var(--pf-06);
  font-size: 12.5px;
  line-height: 1.5;
  color: #4a4a4a;
}
.moo-update-profile-modal .profile-note--reward {
  margin: 4px 0 12px;
}
.moo-update-profile-modal .profile-note .material-icons-round {
  font-size: 16px;
  line-height: 1.35;
  flex: 0 0 auto;
}
.moo-update-profile-modal .profile-choices {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 18px;
  padding: 4px 2px;
}
.moo-update-profile-modal .profile-choices--stack {
  flex-direction: column;
  gap: 8px;
}
.moo-update-profile-modal .profile-choice {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-size: 14px;
  color: #1a1c1a;
  cursor: pointer;
}
/* The shared width/padding rule above is for text inputs; a radio or checkbox
   given a 100% width and 12px padding stretches into a grey slab. */
.moo-update-profile-modal .profile-choice input {
  width: auto;
  padding: 0;
  background: none;
  accent-color: var(--pf);
  flex: 0 0 auto;
}
.moo-update-profile-modal .profile-choice input:focus {
  box-shadow: none;
}
.moo-update-profile-modal .profile-phone-btn {
  flex: 0 0 auto;
  border: none;
  border-radius: 12px;
  background: var(--pf);
  color: #ffffff;
  padding: 0 14px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  cursor: pointer;
  min-width: 76px;
}
.moo-update-profile-modal .profile-phone-btn:disabled {
  background: var(--pf-06);
  color: #9a9a9a;
  cursor: not-allowed;
}
.moo-update-profile-modal .profile-otp {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 10px;
}
/* VOtpInput renders `div[style=display:flex] > div > input`, and the inline
   style on that wrapper is out of reach — but it is already flex, so the row
   only needs a gap and a justification. Small boxes centred in the row: the
   class handed to it via input-classes lands on the inner input, which scoped
   CSS cannot see without :deep(). */
.moo-update-profile-modal :deep(.profile-otp-row > div) {
  gap: 10px;
  justify-content: center;
}
/* `.profile-field input` above is (0,2,1) and would otherwise win on width and
   padding, stretching each box across the whole row. */
.moo-update-profile-modal :deep(.profile-field input.pf-otp) {
  width: 44px;
  height: 44px;
  margin: 0;
  padding: 5px;
  font-size: 20px;
  text-align: center;
  border: none;
  border-radius: 12px;
  background: var(--pf-06);
  color: #1a1c1a;
  outline: none;
}
.moo-update-profile-modal :deep(.profile-field input.pf-otp:focus) {
  box-shadow: 0 0 0 2px var(--pf);
}
.moo-update-profile-modal :deep(.profile-field input.pf-otp::-webkit-inner-spin-button),
.moo-update-profile-modal :deep(.profile-field input.pf-otp::-webkit-outer-spin-button) {
  -webkit-appearance: none;
  margin: 0;
}
.moo-update-profile-modal .profile-file-input {
  display: none;
}
.moo-update-profile-modal .profile-file {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.moo-update-profile-modal .profile-file-btn {
  border: 1px solid var(--pf);
  border-radius: 9999px;
  background: transparent;
  color: var(--pf);
  padding: 7px 16px;
  font-size: 12.5px;
  font-weight: 700;
  cursor: pointer;
}
.moo-update-profile-modal .profile-file-preview {
  position: relative;
  display: inline-block;
  margin-top: 10px;
}
.moo-update-profile-modal .profile-file-preview img {
  max-width: 96px;
  max-height: 96px;
  border-radius: 10px;
  display: block;
}
.moo-update-profile-modal .profile-file-clear {
  position: absolute;
  top: -8px;
  right: -8px;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 50%;
  background: #1a1c1a;
  color: #ffffff;
  cursor: pointer;
  padding: 0;
}
.moo-update-profile-modal .profile-file-clear .material-icons-round {
  font-size: 14px;
}
</style>
